module.exports = "pegasus/assets/background-patterns/default-space-theme.jpg";